import { QuestionId, QuestionVariant, TranslationData } from "@common";
import { TeacherModeQuizModule } from "@natklok/config/teacherModeQuizModules";
import { DiscussionSlideData } from "../config/discussionSlideData";
import { AnswerStat } from "../interfaces/answerStats.interface";
import {
  InformationSlideData,
  QuizSlideDataSequence,
  SlideData,
} from "../interfaces/question.interface";
import {
  createAnswerStatForDiscussionSlide,
  createAnswerStatForQuestion,
} from "./createAnswerStat";

export const createQuestionSlideData = ({
  questionIdOrVariant,
  defaultSlideDatas,
}: {
  questionIdOrVariant: QuestionId | QuestionVariant;
  defaultSlideDatas: QuizSlideDataSequence;
}): SlideData | undefined => {
  const defaultQuestions: Array<SlideData> = defaultSlideDatas;

  const slideData = defaultQuestions.find((slideData: SlideData) => {
    if (slideData.question) {
      if (
        slideData.question.id.sv === questionIdOrVariant ||
        slideData.question.variant.sv === questionIdOrVariant
      )
        return slideData;
    }
  });

  if (slideData?.question !== undefined) {
    const answerStat: AnswerStat | undefined = createAnswerStatForQuestion(slideData.question);
    if (answerStat !== undefined) {
      const newSlideData: SlideData = { ...slideData, answerStat };
      return newSlideData;
    } else {
      console.error(
        "Couldn't create a answerStat whilst trying to compose the quiz slide data sequence."
      );
    }
  }
};

export const createInfoSlideData = (infoSlideData: InformationSlideData): SlideData => {
  const newSlideData: SlideData = {
    state: "unanswered",
    completed: false,
    savedInStorage: false,
    information: infoSlideData,
  };
  return newSlideData;
};

export const createDiscussionSlideData = (
  discSlideData: DiscussionSlideData
): SlideData | undefined => {
  const answerStat: AnswerStat | undefined = createAnswerStatForDiscussionSlide(discSlideData);
  if (answerStat !== undefined) {
    const newSlideData: SlideData = {
      state: "unanswered",
      completed: false,
      savedInStorage: false,
      discussion: discSlideData,
      answerStat: answerStat,
    };
    return newSlideData;
  }
};

export const generateQuizSlideDataSequenceFromTeacherModeQuiz = ({
  teacherModeQuizModule,
  defaultSlideDatas,
  translateTranslationData,
}: {
  teacherModeQuizModule: TeacherModeQuizModule;
  defaultSlideDatas: QuizSlideDataSequence;
  translateTranslationData: (translationData: TranslationData | undefined) => string;
}): QuizSlideDataSequence => {
  const slideDatas: QuizSlideDataSequence = [];

  const introSlideData = createInfoSlideData({
    title: translateTranslationData(teacherModeQuizModule.introSlideTitle),
    desc: translateTranslationData(teacherModeQuizModule.introSlideDesc),
    type: "lecture",
    youtubeID: teacherModeQuizModule.youtubeID,
  });
  slideDatas.push(introSlideData);

  teacherModeQuizModule.questionIdsOrVariants.forEach((questionId: QuestionId) => {
    const slideData = createQuestionSlideData({
      questionIdOrVariant: questionId,
      defaultSlideDatas,
    });
    console.log("slideData: ", slideData);

    if (slideData !== undefined) slideDatas.push(slideData);
  });

  teacherModeQuizModule.discussionSlides.forEach((discussionSlide) => {
    if (discussionSlide !== undefined) {
      const slideData = createDiscussionSlideData(discussionSlide);
      if (slideData !== undefined) slideDatas.push(slideData);
    }
  });
  return slideDatas;
};
